<template>
  <div>

    <v-dialog
        v-model="dialog"
        width="90%"
    >
      <v-card>
        <v-card-title>
          Selecione a imagem desejada ou adicione mais na sua galeria
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col
                cols="6"
                md="4"
            >
              <v-alert v-if="uploadMessage" border="left">
                {{ uploadMessage }}
              </v-alert>

              <v-progress-linear
                  v-show="uploadProgress > 0"
                  v-model="uploadProgress"
                  color="light-blue"
                  height="25"
                  reactive
              >
                <strong>{{ uploadProgress }} %</strong>
              </v-progress-linear>

              <v-form ref="form">
                <v-file-input
                    label="Adicione imagens e vídeos"
                    dense
                    accept="image/*, video/*"
                    multiple
                    counter
                    show-size
                    prepend-icon="mdi-image-search"
                    @change="doUpload"
                    v-model="inputFile"
                >
                  <template v-slot:selection="{ text }">
                    <v-chip
                        small
                        label
                        color="primary"
                    >
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>

        <v-container fluid>
          <v-row>
            <v-col
                v-for="(img, k) in imgs"
                :key="k"
                class="d-flex child-flex"
                cols="2"
            >
              <v-card flat outlined class="d-flex flex-column">

                <v-img
                    v-if="!isVideo(img.nome_unico)"
                    :src="`/${$store.state.serverImgUserPath}/${img.nome_unico}`"
                    height="200"
                    class="grey darken-4"
                    contain
                >
                  <template v-slot:placeholder>
                    <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                    >
                      <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>

                <video
                    v-if="isVideo(img.nome_unico)"
                    preload="metadata"
                    controls
                    height="200"
                    width="100%"
                    class="grey darken-4"
                >
                  <source :src="`/${$store.state.serverImgUserPath}/${img.nome_unico}#t=0.5`" type='video/mp4'>
                </video>

                <v-card-text class="text-body-2">
                  {{ img.nome_original }}
                </v-card-text>

                <v-spacer></v-spacer>

                <v-card-actions>
                  <v-row>
                    <v-col class="col-6" align="left">
                      <a
                          @click="update(img)"
                          class="text-body-2"
                      >
                        Selecionar
                      </a>
                    </v-col>
                    <v-col class="col-6" align="right">
                      <a @click="deleteItem(img)">
                        <v-icon
                            color="error"
                        >
                          mdi-delete
                        </v-icon>
                      </a>
                    </v-col>
                  </v-row>
                </v-card-actions>

              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="primary darken-1"
              text
              @click="dialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <slot name="default" :open="openDialog">
      <v-row dense no-gutters>
        <v-col>
          <v-btn
              small
              depressed
              style="border: 1px gray solid"
              @click="openDialog"
          >
            <v-icon>
              mdi-folder-image
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </slot>

  </div>
</template>

<script>
import {isVideo} from '../libs/utils';

export default {
  name: "ImageGallery",
  props: {
    value: {
      type: String,
      required: false
    },
    dialog: {
      type: Boolean,
      required: false
    },
  },

  data() {
    return {
      endpoint: 'imagens',
      // dialog: false,

      inputFile: null,

      uploadProgress: 0,
      uploadMessage: "",

      imgs: [],
    }
  },

  methods: {
      isVideo(fileName){
          // de utils.js
          return isVideo(fileName);
      },

    openDialog: function () {
      this.dialog = true;
      this.getFromApi();
    },

    update: function (oImg) {
      this.$emit('input', oImg);
      this.dialog = false;
    },

    doUpload: function (files) {
      this.uploadMessage = "";

      if (!files.length) {
        return false;
      }

      let formData = new FormData();

      for (const i in files) {
        formData.append("files[" + i + "]", files[i]);
      }

      axios.post(this.$store.getters.getUsrEndpoint + '/imagens', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: function (progressEvent) {
          this.uploadProgress = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this)
      }).then((response) => {
        this.uploadMessage = response.data.message;
        this.inputFile = null;
        this.getFromApi();
        // return UploadService.getFiles();
      }).then((files) => {
        this.fileInfos = files.data;
      }).catch((e) => {
        this.uploadProgress = 0;
        this.uploadMessage = e.response.data.msg;
        // this.currentFile = undefined;
      });
      // this.uploadProgress = Math.round((100 * event.loaded) / event.total);
    },

    getFromApi() {
      this.loading = true;

      axios.get(this.$store.getters.getUsrEndpoint + '/imagens')
          .then((response) => {
                this.imgs = response.data.items;

                this.loading = false;
              }, (error) => {
                console.log(error);
              }
          )
          .catch(error => {
            console.log(error)
            // this.errored = true
          })
          .finally(() => this.loading = false)
      ;
    },

    deleteItem(item) {
      const index = this.imgs.indexOf(item)
      if (confirm('Tem certeza que quer remover este item?')) {
        axios
            .delete('/' + this.endpoint + '/' + item.id)
            .then((response) => {
                  // this.close();
                  // this.dialog = false

                  // this.items.splice(index, 1);
                  // this.totalItems = this.totalItems - 1;
                  this.getFromApi();

                }, (error) => {
                  this.alertDialog = true;
                  // if (error.response.status == 409) {
                  // }
                  this.alertDialogText = "Houve um problema ao remover o registro";
                }
            )
            .catch(error => {
              console.log(error)
              // this.errored = true
            })
            .finally(() => {
              this.loading = false;
              this.loader = null;
            });
      }
    },
  },
}
</script>
